export const SUCCESS_NOTIFICATION_TEXT = 'Registration request submitted'
export const FIELDS_CONFIG = [
  {
    label: 'Email',
    field: 'Email',
    required: true,
  },
  {
    label: 'First Name',
    field: 'FirstName',
    required: true,
  },
  {
    label: 'Last Name',
    field: 'LastName',
    required: true,
  },
  {
    label: 'Select Role',
    field: 'SelectRole',
    required: true,
  },
  {
    label: 'Country',
    field: 'SelectCountry',
    required: false,
  },
  {
    label: 'Market',
    field: 'SelectMarket',
    required: false,
  },
]
